// Adapter Meta Pixel — consome window.fbq (criado pelo componente PixelBus).
// Schema Pixel: { content_ids, content_type:'product', contents:[{id,quantity,item_price}],
//                 value, currency } + eventID (= event_id) para deduplicação.
import { isPixelEnabled } from "../config";

const CURRENCY = "BRL";

export function sendPixel(meta, payload) {
  // Early-return se o Pixel não está habilitado para a empresa OU o evento
  // canônico não tem evento padrão equivalente na Meta.
  if (!isPixelEnabled() || !meta.pixel) return;

  const items = payload.items || [];
  const data = { currency: payload.currency || CURRENCY };

  if (items.length > 0) {
    data.content_type = "product";
    data.content_ids = items.map((it) => it.id);
    data.contents = items.map((it) => ({
      id: it.id,
      quantity: it.quantidade,
      item_price: it.preco,
    }));
  }

  if (payload.value != null) data.value = payload.value;
  if (payload.search_term) data.search_string = payload.search_term;

  window.fbq("track", meta.pixel, data, { eventID: payload.event_id });
}

export default sendPixel;
